// extracted by mini-css-extract-plugin
export default {"container":"_3v-VH1EBcKBDlKvyx57fMe"};